(function () {
  'use strict';

  var opener = document.querySelector('[data-acha-opener]');
  if (!opener) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var regions = Array.prototype.slice.call(document.querySelectorAll('main, body > footer'));
  var leaveTimer = 0;
  var hideTimer = 0;

  function unlock() {
    regions.forEach(function (region) { region.removeAttribute('inert'); });
    document.documentElement.style.overflow = '';
  }

  function finish() {
    if (opener.hidden) return;
    window.clearTimeout(leaveTimer);
    window.clearTimeout(hideTimer);
    opener.classList.add('is-leaving');
    hideTimer = window.setTimeout(function () {
      opener.hidden = true;
      opener.className = 'acha-opener';
      unlock();
    }, 640);
  }

  function play() {
    if (reduced.matches) return;
    window.clearTimeout(leaveTimer);
    window.clearTimeout(hideTimer);
    opener.hidden = false;
    opener.className = 'acha-opener';
    regions.forEach(function (region) { region.setAttribute('inert', ''); });
    document.documentElement.style.overflow = 'hidden';
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { opener.classList.add('is-playing'); });
    });
    leaveTimer = window.setTimeout(finish, 1640);
  }

  if (reduced.matches) {
    opener.hidden = true;
    unlock();
  } else {
    play();
  }

  var skip = document.querySelector('[data-acha-opener-skip]');
  if (skip) skip.addEventListener('click', finish);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !opener.hidden) finish();
  });
}());
